import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { Row, Col, Cell, CellGroup, Field, Button, Overlay, Loading } from 'vant';
import 'vant/lib/index.css';

Vue.config.productionTip = false;
Vue.use(Row)
   .use(Col)
   .use(Cell)
   .use(CellGroup)
   .use(Field)
   .use(Button)
   .use(Overlay)
   .use(Loading);

new Vue({
   router,
   render: function (h) { return h(App) }
}).$mount('#app')
